import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type UploadFileInput = {
  formData: FormData;
};
const uploadFileAsync = ({ formData }: UploadFileInput) =>
  axios.put(`/clients/file`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const useUploadFileAsync = () =>
  useMutation({
    mutationFn: uploadFileAsync,
  });
